import { hubbleAPI } from './url'
const resource = hubbleAPI + 'secure/public/lead'
export default ($axios) => ({
  addLead(leadDTO) {
    return $axios.put(`${resource}`, leadDTO)
  }
})
